import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import $ from 'jquery';
import { TablePagination } from '@material-ui/core';
import PlayCircleFilledOutlined from '@material-ui/icons/PlayCircleFilledOutlined';
import ToggleBtn from 'ui/components/toggle-button';
import Progress from '../ui/react-ui/progress.jsx';
import PopupDialog from 'ui/components/popup-dialog';
import Tabs from '../ui/react-ui/tabs';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import DeviceEdit from './device-edit';
import AnalyticCameraEdit from './analyticCamera-edit';
import VideoPlayerPopup from './videoPlayer-popup'; // api

import { getNvrList, deleteMultipleNVRAPI } from '../../api/settingAPI';
import { getDeviceCameras, editCameraAPI, deleteMultipleCameraAPI, getCameraVaProfileList, getTipcCctvList, deleteCameraVaProfileAPI } from '../../api/deviceAPI';
import { getHarborListAll } from '../../api/areaAPI'; // redux

import { setAnalyticCameraList, setCctvCameraList, setRoadCameraList, setNvrList, setTipcCctvCameraList, clearDialogInfo, setNvrOptions, setHarborOptions, setAnalyticCameraSort, setCctvSort, setRoadSort, setNvrSort, setTipcSort, setDialogInfo, reset } from '../../redux/setting-device';
var t = i18n.getFixedT(null, 'setting-device');
var gt = i18n.getFixedT(null, 'app');
var Device = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$device = _useSelector.device,
      analyticCameraList = _useSelector$device.analyticCameraList,
      cctvCameraList = _useSelector$device.cctvCameraList,
      roadCameraList = _useSelector$device.roadCameraList,
      nvrList = _useSelector$device.nvrList,
      tipcCctvCameraList = _useSelector$device.tipcCctvCameraList,
      analyticCameraSort = _useSelector$device.analyticCameraSort,
      cctvSort = _useSelector$device.cctvSort,
      roadSort = _useSelector$device.roadSort,
      nvrSort = _useSelector$device.nvrSort,
      tipcSort = _useSelector$device.tipcSort;

  var dispatch = useDispatch(); // page table size

  var id = props.id;

  var _useState = useState('analyticCamera'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTab = _useState2[0],
      setCurrentTab = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = useState(1),
      _useState6 = _slicedToArray(_useState5, 2),
      totalCount = _useState6[0],
      setTotalCount = _useState6[1];

  var _useState7 = useState(10),
      _useState8 = _slicedToArray(_useState7, 2),
      rowsPerPage = _useState8[0],
      setRowsPerPage = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedItems = _useState10[0],
      setSelectedItems = _useState10[1];

  var _useState11 = useState(),
      _useState12 = _slicedToArray(_useState11, 2),
      terminalSlected = _useState12[0],
      setTerminalSlected = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2),
      keyword = _useState14[0],
      setKeyword = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      openAnalyticCameraEdit = _useState16[0],
      setOpenAnalyticCameraEdit = _useState16[1];

  var _useState17 = useState({}),
      _useState18 = _slicedToArray(_useState17, 2),
      videoData = _useState18[0],
      setVideoData = _useState18[1];

  var _useState19 = useState({}),
      _useState20 = _slicedToArray(_useState19, 2),
      analyticCameraData = _useState20[0],
      setAnalyticCameraData = _useState20[1];

  var _isMounted = useRef(false);

  var _currentData = useRef([]);

  var _deleteAPI = useRef();

  var _isResetUseState = useRef(false);

  var tabsMenu = [{
    key: 'analyticCamera',
    title: t('lbl-analytic-camera')
  }, {
    key: 'cctv',
    title: t('lbl-cctv')
  }, {
    key: 'road',
    title: t('lbl-road')
  }, {
    key: 'nvr',
    title: t('lbl-nvr')
  }, {
    key: 'tipcCctv',
    title: t('lbl-tipc-cctv')
  }];

  var handleOpenDialog = function handleOpenDialog(mode, data) {
    dispatch(setDialogInfo({
      mode: "".concat(currentTab, ".").concat(mode),
      data: mode === 'edit' || mode === 'detial' ? data : {}
    }));
  };

  var handleSort = function handleSort(sort) {
    switch (currentTab) {
      case 'analyticCamera':
        return dispatch(setAnalyticCameraSort(sort));

      case 'cctv':
        return dispatch(setCctvSort(sort));

      case 'road':
        return dispatch(setRoadSort(sort));

      case 'nvr':
        return dispatch(setNvrSort(sort));

      case 'tipcCctv':
        return dispatch(setTipcSort(sort));

      default:
        return null;
    }
  };

  var getProfileObj = function getProfileObj(list) {
    return new Promise(function (resolve, reject) {
      var nvrIpList = _.uniq(_.map(list, function (e) {
        return e.nvr.ip;
      }));

      var profileObj = {};

      var getData = function getData(nvrIp) {
        getCameraVaProfileList(contextRoot, true, nvrIp).then(function (result) {
          nvrIpList.shift();

          var profileData = _.filter(result.content, function (el) {
            return el.modification === true;
          });

          if (_.isEmpty(profileObj[nvrIp])) profileObj[nvrIp] = _toConsumableArray(profileData);
          if (nvrIpList.length > 0) getData(nvrIpList[0]);else resolve(profileObj);
        });
      };

      getData(nvrIpList[0]);
    });
  }; // To delete camera analytics
  // const handleDeleteCameraAnalytic = items => {
  //     return new Promise((resolve, reject) => {
  //         if(currentTab !== 'analyticCamera')
  //             return resolve('success')
  //         getProfileObj(items).then(vaProfileObj => {
  //             let deleteItemAry = _.compact(_.map(items, el => {
  //                 let profileData = _.filter(vaProfileObj[el.nvr.ip], e => e.note.channel === el.channel)[0]
  //                 if(!_.isEmpty(profileData) && profileData.id)
  //                     return {
  //                         nvrIp: el.nvr.ip,
  //                         profileId: profileData.id
  //                     }
  //             }))
  //             const deleteVaProfile = ({nvrIp, profileId}) => {
  //                 deleteCameraVaProfileAPI(contextRoot, true, nvrIp, profileId).then(result => {
  //                     deleteItemAry.shift()
  //                     if(deleteItemAry.length > 0)
  //                         deleteVaProfile(deleteItemAry[0])
  //                     else
  //                         resolve('success')
  //                 })
  //             }
  //             if(deleteItemAry.length > 0)
  //                 deleteVaProfile(deleteItemAry[0])
  //             else
  //                 resolve('success')
  //         })
  //     })
  // }


  var handleDelete = function handleDelete(singleId) {
    var deleteItems = [];
    if (singleId) deleteItems.push(singleId);else _.forEach(selectedItems, function (id) {
      return deleteItems.push(id);
    });

    var deleteList = _.filter(_currentData.current, function (el) {
      return _.some(deleteItems, function (id) {
        return id === el.id;
      });
    });

    var deleteText = _.join(_.map(deleteList, function (el) {
      return el.name;
    }), ', ');

    PopupDialog.confirm({
      title: t("dlg-delete-".concat(currentTab)),
      display: t("txt-delete-".concat(currentTab), {
        device: deleteText
      }),
      cancelText: gt('global.lbl-answer-cancel'),
      confirmText: gt('global.lbl-answer-ok'),
      act: function act(confirmed) {
        if (confirmed) {
          Progress.startSpin();

          _deleteAPI.current(contextRoot, true, deleteItems).then(function (result) {
            Progress.done();
            setSelectedItems([]);
            fetchData();
          }).catch(function (error) {
            Progress.done();
            PopupDialog.alert({
              display: error.message,
              confirmText: gt('global.lbl-answer-ok')
            });
          }); // handleDeleteCameraAnalytic(deleteList).then(r => {
          //     _deleteAPI.current(contextRoot, true, deleteItems).then(result => {
          //         Progress.done()
          //         setSelectedItems([])
          //         fetchData()
          //     }).catch(error => {
          //         Progress.done()
          //         PopupDialog.alert({display:error.message,confirmText: gt('global.lbl-answer-ok')})
          //     })
          // })

        }
      }
    });
  };

  var handleChangePage = function handleChangePage(e, newPage) {
    setCurrentPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var handleCloseDialog = function handleCloseDialog() {
    dispatch(clearDialogInfo());
    fetchData();
    setSelectedItems([]);
  };

  var fetchData = function fetchData() {
    var isInit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var _currentPage, _rowsPerPage, _keyword;

    _currentPage = isInit ? 0 : currentPage;
    _rowsPerPage = isInit ? 10 : rowsPerPage;
    _keyword = isInit ? '' : keyword;
    var offset = (Number(_currentPage + 1) - 1) * rowsPerPage;

    switch (currentTab) {
      case 'analyticCamera':
        getDeviceCameras(contextRoot, false, _keyword, analyticCameraSort, offset, _rowsPerPage, false, true, terminalSlected).then(function (result) {
          var analyticCameraListData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setAnalyticCameraList(analyticCameraListData));
          setTotalCount(result.totalElements);
        });
        break;

      case 'cctv':
        getDeviceCameras(contextRoot, false, _keyword, cctvSort, offset, _rowsPerPage, false, false).then(function (result) {
          var cctvCameraListData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setCctvCameraList(cctvCameraListData));
          setTotalCount(result.totalElements);
        });
        break;

      case 'road':
        getDeviceCameras(contextRoot, false, _keyword, roadSort, offset, _rowsPerPage, true, false).then(function (result) {
          var roadCameraListData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setRoadCameraList(roadCameraListData));
          setTotalCount(result.totalElements);
        });
        break;

      case 'nvr':
        getNvrList(contextRoot, false, _keyword, nvrSort, offset, _rowsPerPage).then(function (result) {
          var newNvrOptions = _.map(result.content, function (el) {
            return {
              value: _.trim(el.id),
              text: el.name
            };
          });

          dispatch(setNvrOptions(newNvrOptions));

          var nvrListData = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setNvrList(nvrListData));
          setTotalCount(result.totalElements);
        });
        break;

      case 'tipcCctv':
        getTipcCctvList(contextRoot, false, _keyword, tipcSort, offset, _rowsPerPage).then(function (result) {
          var tipcCctvList = _.map(result.content, function (el, index) {
            return _objectSpread(_objectSpread({}, el), {}, {
              sequence: offset + index + 1
            });
          });

          dispatch(setTipcCctvCameraList(tipcCctvList));
          setTotalCount(result.totalElements);
        });
        break;

      default:
        break;
    }
  };

  var handleToggleStatus = function handleToggleStatus(data, val) {
    var newData = _.cloneDeep(data);

    _.set(newData, 'isShowOnMap', val);

    var updatedData = _.omit(newData, ['streamUrl', 'streamUrlType']);

    Progress.startSpin();
    editCameraAPI(contextRoot, true, updatedData).then(function (result) {
      fetchData();
    }).catch(function (error) {
      console.log(error);
      Progress.done();
    });
  };

  useEffect(function () {
    if (!_isMounted.current) return;
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [JSON.stringify(analyticCameraSort), JSON.stringify(cctvSort), JSON.stringify(roadSort), JSON.stringify(nvrSort), JSON.stringify(tipcSort), currentPage, rowsPerPage]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (currentPage !== 0) return setCurrentPage(0);
    if (!_isResetUseState.current) fetchData();
    _isResetUseState.current = false;
  }, [keyword]);
  useEffect(function () {
    if (!_isMounted.current) return;
    if (keyword !== '' || currentPage !== 0 || rowsPerPage !== 10 || selectedItems.length > 0) _isResetUseState.current = true;
    setCurrentPage(0);
    setRowsPerPage(10);
    setKeyword('');
    setTerminalSlected('');
    setSelectedItems([]);
    _currentData.current = [];
    fetchData(true);
  }, [currentTab]);
  useEffect(function () {
    if (_isMounted.current === false) {
      // get analysisCameraSort camera list
      var deviceCameras = getDeviceCameras(contextRoot, false, '', analyticCameraSort, 0, 10, false, true); // get NVR selector options

      var _nvrList = getNvrList(contextRoot, false, '', nvrSort, 0, null); //get all harbor


      var harborListAll = getHarborListAll(contextRoot, false);
      $.when(deviceCameras, _nvrList, harborListAll).then(function (cameraResult, nvrListResult, harborListResult) {
        // camera list
        var cameraListData = _.map(cameraResult.content, function (el, index) {
          return _objectSpread(_objectSpread({}, el), {}, {
            sequence: index + 1
          });
        });

        dispatch(setAnalyticCameraList(cameraListData));
        setTotalCount(cameraResult.totalElements); // NVR selector options

        var newNvrOptions = _.map(nvrListResult.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setNvrOptions(newNvrOptions)); // harbor selector options

        var newHarborOptions = _.map(harborListResult.content, function (el) {
          return {
            value: _.trim(el.id),
            text: el.name
          };
        });

        dispatch(setHarborOptions(newHarborOptions));
      });
      _isMounted.current = true;
    }

    return function () {
      dispatch(reset());
    };
  }, []);
  var fields = {},
      sort = null;

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  switch (currentTab) {
    case 'analyticCamera':
      sort = analyticCameraSort;
      _deleteAPI.current = deleteMultipleCameraAPI;
      _currentData.current = analyticCameraList; // _.set(fields, 'terminal', { label: t('lbl-terminals'), sortable:true,
      //     formatter: (val, row) => (<span>{val ? val.name : ''}</span>)
      // })
      // _.set(fields, 'deliverType', { label: t('lbl-container-deliver-types'), sortable:true,
      //     formatter: (val, row) => t('lbl-' + val.toUpperCase())
      // })

      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        sortable: true
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val;
        }
      });

      _.set(fields, 'nvr', {
        label: t('lbl-nvr'),
        sortable: true,
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("span", null, val ? val.name : '');
        }
      });

      _.set(fields, 'channel', {
        label: t('lbl-nvr-channel'),
        sortable: true
      });

      _.set(fields, 'monitor', {
        label: t('lbl-playback'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return setVideoData(row);
            }
          }, /*#__PURE__*/React.createElement(PlayCircleFilledOutlined, null)));
        }
      });

      _.set(fields, 'isShowOnMap', {
        label: t('lbl-show-map-status'),
        sortable: true,
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement(ToggleBtn, {
            onChange: function onChange(val) {
              return handleToggleStatus(row, val);
            },
            on: val
          });
        }
      });

      break;

    case 'cctv':
      sort = cctvSort;
      _deleteAPI.current = deleteMultipleCameraAPI;
      _currentData.current = cctvCameraList;

      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        sortable: true
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val;
        }
      });

      _.set(fields, 'nvr', {
        label: t('lbl-nvr'),
        sortable: true,
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("span", null, val ? val.name : '');
        }
      });

      _.set(fields, 'channel', {
        label: t('lbl-nvr-channel'),
        sortable: true
      });

      _.set(fields, 'monitor', {
        label: t('lbl-playback'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return setVideoData(row);
            }
          }, /*#__PURE__*/React.createElement(PlayCircleFilledOutlined, null)));
        }
      });

      _.set(fields, 'isShowOnMap', {
        label: t('lbl-show-map-status'),
        sortable: true,
        formatter: function formatter(val, row) {
          if (row.sourceType === 'FlatFile') return null;
          return /*#__PURE__*/React.createElement(ToggleBtn, {
            onChange: function onChange(val) {
              return handleToggleStatus(row, val);
            },
            on: val
          });
        }
      });

      break;

    case 'road':
      sort = roadSort;
      _currentData.current = roadCameraList;

      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val;
        }
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val;
        }
      });

      _.set(fields, 'latlng', {
        label: t('lbl-lat-lng'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", null, row.latitude + ', ' + row.longitude);
        }
      });

      _.set(fields, 'streamUrl', {
        label: t('lbl-connected-video-url'),
        sortable: true,
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("span", null, val);
        }
      });

      _.set(fields, 'monitor', {
        label: t('lbl-playback'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", {
            className: "icon-block"
          }, /*#__PURE__*/React.createElement("a", {
            onClick: function onClick() {
              return setVideoData(row);
            }
          }, /*#__PURE__*/React.createElement(PlayCircleFilledOutlined, null)));
        }
      });

      _.set(fields, 'isShowOnMap', {
        label: t('lbl-show-map-status'),
        sortable: true,
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement(ToggleBtn, {
            onChange: function onChange(val) {
              return handleToggleStatus(row, val);
            },
            on: val
          });
        }
      });

      break;

    case 'nvr':
      sort = nvrSort;
      _deleteAPI.current = deleteMultipleNVRAPI;
      _currentData.current = nvrList;

      _.set(fields, 'name', {
        label: t('lbl-nvr-name'),
        sortable: true
      });

      _.set(fields, 'ip', {
        label: t('lbl-ip'),
        sortable: true
      });

      _.set(fields, 'port', {
        label: t('lbl-port'),
        sortable: true
      });

      _.set(fields, 'ivarId', {
        label: t('lbl-ivar-id'),
        sortable: true
      });

      break;

    case 'tipcCctv':
      sort = tipcSort;
      _currentData.current = tipcCctvCameraList;

      _.set(fields, 'name', {
        label: t('lbl-camera-name'),
        sortable: true,
        formatter: function formatter(val, row) {
          return val;
        }
      });

      _.set(fields, 'location', {
        label: t('lbl-location'),
        sortable: false,
        formatter: function formatter(val, row) {
          return row.harbor + '-' + row.area;
        }
      });

      _.set(fields, 'latlng', {
        label: t('lbl-lat-lng'),
        formatter: function formatter(val, row) {
          return /*#__PURE__*/React.createElement("div", null, row.latitude + ', ' + row.longitude);
        }
      });

      _.set(fields, 'nvrName', {
        label: t('lbl-nvr-name'),
        sortable: true
      });

      _.set(fields, 'nvrIp', {
        label: t('lbl-nvr-ip'),
        sortable: true
      });

      _.set(fields, 'nvrChannel', {
        label: t('lbl-nvr-channel'),
        sortable: true
      });

      break;
  }

  if (currentTab !== 'tipcCctv') {
    _.set(fields, 'status', {
      label: t('lbl-status'),
      sortable: true,
      formatter: function formatter(val, row) {
        return val ? t('lbl-online') : t('lbl-offline');
      }
    });
  }

  var renderFieldsMore = function renderFieldsMore(data) {
    if (currentTab === 'road' || currentTab === 'tipcCctv') return /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        return handleOpenDialog('detial', data);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-list-alt"
    }));
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        return handleOpenDialog('edit', data);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-pencil-alt fa-list-alt"
    })), currentTab === 'analyticCamera' && /*#__PURE__*/React.createElement("a", {
      onClick: function onClick() {
        setAnalyticCameraData(data);
        setOpenAnalyticCameraEdit(true);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-cog"
    })), /*#__PURE__*/React.createElement("a", {
      className: "delete",
      onClick: function onClick() {
        return handleDelete(data.id);
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-trash"
    })));
  };

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, renderFieldsMore(row));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "device-headBar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(searchText) {
      if (_.isEmpty(keyword) && _.isEmpty(searchText) && currentPage !== 0) return setCurrentPage(0);
      if (_.isEmpty(keyword)) fetchData();
      setKeyword(searchText);
    },
    value: keyword
  }), !(currentTab === 'road' || currentTab === 'tipcCctv') && /*#__PURE__*/React.createElement("a", {
    className: "icon",
    onClick: function onClick() {
      return handleOpenDialog('create');
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }))), /*#__PURE__*/React.createElement(Tabs, {
    id: "g-device-tabs",
    menu: tabsMenu,
    current: currentTab,
    className: cx({
      'road': currentTab === 'road' || currentTab === 'tipcCctv'
    }),
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: _currentData.current,
    sort: sort,
    onSort: handleSort,
    rowIdField: currentTab === 'tipcCctv' ? '' : 'id',
    selectable: currentTab === 'road' || currentTab === 'tipcCctv' ? false : {
      toggleAll: true
    },
    selected: selectedItems,
    onSelectionChange: function onSelectionChange(val) {
      return setSelectedItems(val);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: t('lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: handleChangePage,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }), !(currentTab === 'road' || currentTab === 'tipcCctv') && /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("button", {
    className: cx('button', 'delete'),
    onClick: function onClick() {
      return handleDelete();
    },
    disabled: selectedItems.length > 0 ? false : true
  }, t('lbl-delete')))), /*#__PURE__*/React.createElement(DeviceEdit, {
    onClose: handleCloseDialog
  }), openAnalyticCameraEdit && /*#__PURE__*/React.createElement(AnalyticCameraEdit, {
    cameraData: analyticCameraData,
    onClose: function onClose() {
      setAnalyticCameraData({});
      setOpenAnalyticCameraEdit(false);
    }
  }), videoData && !_.isEmpty(videoData.id) && /*#__PURE__*/React.createElement(VideoPlayerPopup, {
    videoData: videoData,
    onClose: function onClose() {
      return setVideoData({});
    }
  }));
});
Device.defaultProps = {
  id: 'g-device'
};
Device.PropTypes = {
  id: PropTypes.string
};
export default Device;